import ErrorFeedback from 'Components/ErrorFeedback/ErrorFeedback'
import PageContainer from 'Components/PageContainer'
import { modalEndConditionState } from 'Hooks/useModalEndCondition/useModalEndCondition'
import useBeforeUnload from 'Hooks/useRouteBeforeUnload'
import { Loading, ToastContainer, Tooltip } from 'mailup-web-components'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import Header from './components/Header'
import { ModalConfirmLeave } from './components/ModalConfirmLeave'
import { ModalFilterDetails } from './components/Step3/ModalFilterDetails'
import WizardContainer from './components/WizardContainer'
import {
  initPageCallback,
  resetPageCallback
} from './recoil/callbacks/callbacks'
import { pageState } from './recoil/state/page'
import {
  exceptionsState,
  senderConfigState,
  taskConditionsState,
  taskPanelFrequencyState,
  taskState
} from './recoil/state/task'

const Task = () => {
  const { idTask } = useParams()
  const { loading, loaded, error, severity } = useRecoilValue(pageState)

  const { nameIsDiry, isDirty, isDirtyDetailAction } = useRecoilValue(taskState)
  const { isDirty: taskPanelFrequencyStateIsDirty } = useRecoilValue(
    taskPanelFrequencyState
  )
  const { IsDirty: senderConfigStateIsDirty } =
    useRecoilValue(senderConfigState)
  const { isDirty: consitionStateIsDirty } = useRecoilValue(taskConditionsState)
  const { isDirty: exceptionsStateIsDirty } = useRecoilValue(exceptionsState)
  const { isDirty: GroupisDirty } = useRecoilValue(modalEndConditionState)
  const init = useRecoilCallback(initPageCallback, [])
  const reset = useRecoilCallback(resetPageCallback, [])

  useEffect(() => {
    return () => {
      reset()
    }
  }, [])

  useEffect(() => {
    !loaded && init(idTask)
  }, [loaded])

  useBeforeUnload(
    nameIsDiry ||
      isDirty ||
      GroupisDirty ||
      isDirtyDetailAction ||
      senderConfigStateIsDirty ||
      consitionStateIsDirty ||
      exceptionsStateIsDirty ||
      taskPanelFrequencyStateIsDirty
  )

  return (
    <>
      <Header />
      <Tooltip />
      <ToastContainer />
      <ModalFilterDetails />
      <Loading open={loading} />
      <ToastContainer />
      <ModalConfirmLeave />
      <PageContainer className='c-task'>
        <ErrorFeedback
          error={error}
          severity={severity}
          onClickReload={() => init(idTask)}
        />
        {!error && loaded && (
          <>
            <WizardContainer />
          </>
        )}
      </PageContainer>
    </>
  )
}

export default Task
